import React from 'react';
import AdSpace from './AdSpace';
import './MainLayout.css';

function MainLayout({ children }) {
    return (
        <div className="main-layout">
            {/* Sidebar Izquierdo - Solo desktop */}
            <aside className="sidebar sidebar-left">
                <AdSpace 
                    slot="1298971198"
                    format="vertical"
                    responsive={false}
                    style={{ 
                        width: '160px',
                        minHeight: '600px'
                    }}
                />
            </aside>

            {/* Contenido Principal */}
            <main className="main-content">
                {children}
            </main>

            {/* Sidebar Derecho - Solo desktop */}
            <aside className="sidebar sidebar-right">
                <AdSpace 
                    slot="7672807853"
                    format="vertical"
                    responsive={false}
                    style={{ 
                        width: '160px',
                        minHeight: '600px'
                    }}
                />
            </aside>
        </div>
    );
}

export default MainLayout;